import { UseQueryFn } from 'shared-ui';

import { SettingsResponse } from './general.types';

export const getSettings: UseQueryFn<void, SettingsResponse> = () => {
  return {
    endpoint: `/setting`,
  };
};
